// External Libs
import React from "react"
import moment from "moment"
import { fetch } from "../../services/dataStore"
import { SessionStore } from "../../services/sessionStore"
import { Menu } from "../Menu"
import { MenuProps } from "../Menu/Menu"

export interface UpcomingMenusProps {
  scrollOffset?: Number
}

interface UpcomingMenusState {
  menus: MenuProps[],
  currentDate: Date,
  availableDates: Date[]
}

class UpcomingMenusInner extends React.Component<UpcomingMenusProps, UpcomingMenusState> {
  static defaultProps: UpcomingMenusProps = {
    scrollOffset: 4,
  }

  constructor(props = {}) {
    super(props)

    this.state = {
      menus: [],
      currentDate: null,
      availableDates: [],
    }

    this.renderMenu = this.renderMenu.bind(this)
    this.handleChangeDate = this.handleChangeDate.bind(this)
  }

  componentDidMount() {
    this.loadData()
  }

  handleChangeDate(currentDate: Date) {
    this.setState({ currentDate })
  }

  private async loadData() {
    let data = SessionStore.fetch("upcomingMenus2")

    if (!data) {
      data = await this.fetchData()
      SessionStore.save("upcomingMenus", data)
    }

    const availableDates = this.availableDates(data)
    this.setState({ menus: data, currentDate: availableDates[0], availableDates })
  }

  private availableDates(menus: MenuProps[]) {
    return menus.map((menu) => moment.utc(menu.weekOf).toDate())
  }

  private async fetchData() {
    try {
      const queryString = `{
        menus {
          weekOf
          featuredItems {
            image
            title
            allergens
            customizable
            category {
              id
              name
              sortIndex
            }
            classifications {
              name
              icon
            }
            defaultVariant {
              name
              visible
            }
            variantOptions {
              name
            }
          }
        }
      }`

      const { menus } = await fetch(queryString)

      return menus
    } catch (error) {
      return []
    }
  }

  findMenu(menus: MenuProps[], weekOf: Date) {
    return menus.find((menu) => (new Date(menu.weekOf)).toDateString() === weekOf.toDateString())
  }

  renderMenu(menu: MenuProps) {
    const { scrollOffset } = this.props
    const { availableDates } = this.state
    return (
      <Menu
        {...menu}
        availableDates={availableDates}
        changeDate={this.handleChangeDate}
        scrollOffset={scrollOffset}
      />
    )
  }

  render() {
    const { menus, currentDate } = this.state
    const menu = this.findMenu(menus, currentDate)

    if (menu) {
      return (this.renderMenu(menu))
    }
    return (<div />)
  }
}

export function UpcomingMenus(props: UpcomingMenusProps) {
  return <UpcomingMenusInner {...props} />
}
